import * as React from "react";

import { FeaturesContext } from "context/featurescontext";
import { MyOrgContext } from "context/myorgcontext";
import { UserContext } from "context/usercontext";
import { featureNames } from "src/domain/administrative/resource-management/features/features/utils/features";

export const useAllowLaunchWorkflow = (numOfActiveWorkflows: number, instances: Nodes) => {
  const org = React.useContext(MyOrgContext);
  const user = React.useContext(UserContext);
  const features = React.useContext(FeaturesContext);

  // After Instances are Loaded, determine if we have enough instances to launch a workflow.
  // If we have the gpu feature we need enough instances to launch EITHER a cpu OR gpu workflow.
  const noAvailableInstances: boolean = React.useMemo(() => {
    if (!instances) {
      return false;
    }
    const gpuFeature: boolean = features ? !!features.find((feature) => feature.name == featureNames.GPU) : false;

    const cpusAvailable: boolean = instances?.cpus?.head?.length > 0 && instances?.cpus?.compute?.length > 0;
    const gpusAvailable: boolean = instances?.gpus?.head?.length > 0 && instances?.gpus?.compute?.length > 0;

    return !(gpuFeature ? cpusAvailable || gpusAvailable : cpusAvailable);
  }, [features, instances]);

  const userDisabled = !user.is_enabled;
  const invalidOrg = org.blockWorkflowCreation();
  const workflowLimitReached = numOfActiveWorkflows >= user?.max_workflows;
  const workflowUsernameUnavailable = !user.email && !user.preferred_username;
  const keypairUnavailable = !user?.aws_keypair_name && !org.data.aws_keypair_name;
  const missingNotifArn = !org.data.sns_topic_arn;
  const missingIngressRules = !org.data.use_public_ips && !org.data.has_ingress_rules;

  return {
    userDisabled: userDisabled,
    invalidOrg: invalidOrg,
    workflowLimitReached: workflowLimitReached,
    workflowUsernameUnavailable: workflowUsernameUnavailable,
    keypairUnavailable: keypairUnavailable,
    missingNotifArn: missingNotifArn,
    missingIngressRules: missingIngressRules,
    noAvailableInstances: noAvailableInstances,
    restricted:
      workflowLimitReached ||
      workflowUsernameUnavailable ||
      keypairUnavailable ||
      userDisabled ||
      invalidOrg ||
      missingNotifArn ||
      missingIngressRules ||
      noAvailableInstances,
  };
};
